import React from "react";
import { DeleteButton } from "./DeleteButton";
import {
  DeleteCertificationMutationVariables,
  useDeleteCertificationMutation,
} from "@graphql";

type DeleteCertificationProps = {
  variables: DeleteCertificationMutationVariables;
};

export function DeleteCertification({ variables }: DeleteCertificationProps) {
  const [deleteCertification, { loading }] = useDeleteCertificationMutation({
    variables,
    update(cache, { data }) {
      if (data?.user?.certification) {
        cache.evict({
          id: cache.identify(data.user.certification),
        });
        cache.gc();
      }
    },
  });

  return (
    <DeleteButton
      aria-label="Delete certification"
      isLoading={loading}
      onClick={() => deleteCertification()}
    />
  );
}
